import type React from "react";
import { createContext, type ReactNode, useContext } from "react";
import { useGetNewNotificationCount } from "~hooks/useGetNewNotificationCount.ts";

interface NotificationCountContextType {
  count: number;
  refetchCount: () => Promise<unknown>;
}

const NotificationCountContext = createContext<NotificationCountContextType | undefined>(undefined);

export const NotificationCountProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { data: newNotificationCount, refetch: refetchNewNotificationCount } = useGetNewNotificationCount();

  const notificationCount = newNotificationCount?.[0] || 0;

  return (
    <NotificationCountContext.Provider value={{ count: notificationCount, refetchCount: refetchNewNotificationCount }}>
      {children}
    </NotificationCountContext.Provider>
  );
};

export const useNotificationCount = (): NotificationCountContextType => {
  const context = useContext(NotificationCountContext);
  if (!context) {
    throw new Error("useNotificationCount must be used within a NotificationCountProvider");
  }
  return context;
};
